(function(){
  if (window.__giftWrapALL) return; window.__giftWrapALL = true;

  /* ===== Config ===== */
  var HARD_RELOAD_AFTER_CHANGE = true; // se quiser garantir atualização visual, coloque true

  /* ===== Utils ===== */
  function log(){ try{ console.log('[giftwrap]', ...arguments); }catch(e){} }
  function $(sel, ctx){ return (ctx||document).querySelector(sel); }
  function onCartPage(){ return /\/cart(\/|$|\?)/.test(location.pathname); }

  function setMsg(text, isError){
    var box = document.getElementById('gift-wrap-msg');
    if (!box) return;
    box.textContent = text || '';
    box.style.color = isError ? '#c00' : '#666';
  }

  function getVariantIdFromNode(node){
    var wrap = node && node.closest('[data-gift-variant-id]');
    if (!wrap) return null;
    var raw = wrap.getAttribute('data-gift-variant-id');
    var id = raw ? parseInt(raw, 10) : null;
    return isFinite(id) ? id : null;
  }

  function toggleGiftNote(show){
    document.querySelectorAll('[data-gift-note-wrapper]').forEach(function(el){
      el.style.display = show ? '' : 'none';
    });
  }

  async function tryReplaceByHandle(handle){
    var container = document.getElementById('shopify-section-' + handle);
    if (!container) return false;
    var html = await fetch('/?section_id=' + handle).then(r=>r.text());
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-' + handle);
    if (fresh) container.replaceWith(fresh);
    return true;
  }

  async function refreshUI(){
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

    if (HARD_RELOAD_AFTER_CHANGE || onCartPage()){
      location.reload(); return;
    }

    try {
      // header (muitos mini-carts vivem aqui)
      await tryReplaceByHandle('header');

      // ancestral do mini-cart, se existir
      var mini = document.querySelector('[data-cart-mini-content]');
      if (mini){
        var section = mini.closest('[id^="shopify-section-"]');
        if (section){
          var handle = section.id.replace('shopify-section-','');
          if (handle && handle !== 'header') await tryReplaceByHandle(handle);
        }
      }

      // bolha
      await tryReplaceByHandle('cart-icon-bubble');

      // re-aplica visibilidade da nota
      var cb = document.querySelector('input[name="attributes[gift-wrapping]"]');
      if (cb) toggleGiftNote(cb.checked);
    } catch(e){
      log('refresh fallback -> reload', e);
      location.reload();
    }
  }

  /* ===== Ações (com ID local do wrapper) ===== */
  async function addGiftWithId(variantId){
    if (!variantId){ setMsg('Configuração de gift wrap ausente.', true); return; }
    setMsg('Adicionando embalagem de presente…');

    const addResp = await fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!addResp.ok){
      let err = {}; try { err = await addResp.json(); } catch(e){}
      setMsg((err && err.description) ? err.description : 'Não foi possível adicionar a embalagem.', true);
      log('add.js erro', err);
      return;
    }

    await fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: { 'gift-wrapping': 'yes' } })
    });

    setMsg('');
    await refreshUI();
  }

  async function removeGiftWithId(variantId){
    if (!variantId){ setMsg('Configuração de gift wrap ausente.', true); return; }
    setMsg('Removendo embalagem de presente…');

    const body = { updates: {}, attributes: { 'gift-wrapping': '', 'gift-note': '' } };
    body.updates[variantId] = 0;

    const upd = await fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify(body)
    });
    if (!upd.ok){
      setMsg('Não foi possível remover a embalagem.', true);
      log('update.js erro ao remover', await upd.text());
      return;
    }

    setMsg('');
    await refreshUI();
  }

  /* ===== Nota do pedido (cart.note) com debounce ===== */
  var __noteTimer;
  document.addEventListener('input', function(e){
    if (e.target && (e.target.id === 'cart__note' || e.target.id === 'cart-mini-note')) {
      clearTimeout(__noteTimer);
      var val = e.target.value;
      __noteTimer = setTimeout(function(){
        fetch('/cart/update.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ note: val })
        });
      }, 350);
    }
  });

  /* ===== Toggle (captura e impede conflitos do tema) ===== */
  // Listener em "capture" para evitar que o tema intercepte antes
  document.addEventListener('change', function(e){
    var el = e.target;
    if (!el || el.name !== 'attributes[gift-wrapping]') return;

    // impede handlers do tema interferirem
    try { e.stopImmediatePropagation(); e.stopPropagation(); } catch(_) {}
    // sem preventDefault porque é change, mas se quiser: e.preventDefault();

    // ID específico do bloco onde clicou (cart ou mini-cart)
    var localId = getVariantIdFromNode(el);
    log('toggle gift in context id=', localId, 'checked=', el.checked);

    // mostra/oculta a área de observação imediatamente
    toggleGiftNote(el.checked);

    el.disabled = true;
    var p = el.checked ? addGiftWithId(localId) : removeGiftWithId(localId);
    Promise.resolve(p).finally(function(){ el.disabled = false; });
  }, true); // <— capture = true (pega antes do tema)

  /* ===== Estado inicial (apenas UI da nota) ===== */
  var cbInit = document.querySelector('input[name="attributes[gift-wrapping]"]');
  if (cbInit) toggleGiftNote(cbInit.checked);

  log('ready');
})();
